import React from 'react';
import RichText from '@lmig/dotcom-aspect-components/RichText';

const JSX_POSTFIX = 'jsx';

const convert = obj => {
  if (Array.isArray(obj)) {
    return obj.map(item => convert(item));
  }

  if (typeof obj === 'object' && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, val]) => {
      if (key.split('-')[1] === JSX_POSTFIX) {
        const richText =
          key.split('-')[2] === 'deprecated' ? (
            <RichText jsx={val} renderInWrapper />
          ) : (
            <RichText jsx={val} />
          );

        const keyNoPostfix = key.split('-')[0];

        return { ...acc, [keyNoPostfix]: richText };
      }

      return { ...acc, [key]: convert(val) };
    }, {});
  }

  return obj;
};

const convertObjectWithAstToReact = obj => convert(obj);

export default convertObjectWithAstToReact;
